import React, { useState } from "react";

export default function FooterSettings() {
  const [columns, setColumns] = useState([
    {
      id: 1,
      title: "New Column 1",
      links: [
        { id: 1, label: "", url: "", position: 1 }
      ]
    }
  ]);
  const [openFooter, setOpenFooter] = useState(false); // closed by default
  const [editIndex, setEditIndex] = useState({});

  const handleEditClick = (colIdx, field, linkIdx) => {
    setEditIndex((prev) => ({ ...prev, [`${colIdx}_${field}_${linkIdx ?? ''}`]: true }));
  };

  const handleColumnTitleChange = (idx, value) => {
    const updated = [...columns];
    updated[idx].title = value;
    setColumns(updated);
  };

  const handleLinkChange = (colIdx, linkIdx, field, value) => {
    const updated = [...columns];
    updated[colIdx].links[linkIdx][field] = value;
    setColumns(updated);
  };

  const handleAddColumn = () => {
    setColumns([
      ...columns,
      {
        id: Date.now(),
        title: `New Column ${columns.length + 1}`,
        links: [
          { id: Date.now(), label: "", url: "", position: 1 }
        ]
      }
    ]);
  };

  const handleRemoveColumn = (colIdx) => {
    const updated = columns.filter((_, idx) => idx !== colIdx);
    setColumns(updated);
  };

  const handleAddLink = (colIdx) => {
    const updated = [...columns];
    updated[colIdx].links.push({ id: Date.now(), label: "", url: "", position: updated[colIdx].links.length + 1 });
    setColumns(updated);
  };

  const handleRemoveLink = (colIdx, linkIdx) => {
    const updated = [...columns];
    updated[colIdx].links = updated[colIdx].links.filter((_, idx) => idx !== linkIdx);
    setColumns(updated);
  };

  const handleSave = () => {
    alert("Footer data saved successfully (dummy)");
  };

  return (
    <div style={{ width: "98%", paddingLeft: 24, margin: "0 auto" }}>
      <div style={{ background: "#fff", marginBottom: 24, boxShadow: "0 4px 8px #0001", borderRadius: 8 }}>
        <div
          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: '18px 24px 18px 18px', borderRadius: 8 }}
          onClick={() => setOpenFooter(v => !v)}
        >
          <span style={{ display: 'inline-flex', alignItems: 'center', marginRight: 12 }}>
            <svg width="22" height="22" fill="#888" viewBox="0 0 20 20"><rect x="2" y="2" width="6" height="6" rx="1.5"/><rect x="12" y="2" width="6" height="6" rx="1.5"/><rect x="2" y="12" width="6" height="6" rx="1.5"/><rect x="12" y="12" width="6" height="6" rx="1.5"/></svg>
          </span>
          <span style={{ fontWeight: 400, fontSize: 18, letterSpacing: 0.01 }}>Footer Content</span>
          <span style={{ marginLeft: 'auto', display: 'inline-flex', alignItems: 'center' }}>
            <svg width="22" height="22" fill="#888" viewBox="0 0 20 20" style={{ transform: openFooter ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}><path d="M6 8l4 4 4-4" stroke="#888" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </span>
        </div>
        {openFooter && (
          <div style={{ padding: 24, paddingTop: 0 }}>
            {columns.map((col, colIdx) => (
              <div key={col.id} style={{ background: "#fff", marginBottom: 24, boxShadow: "0 4px 8px #0001", padding: 24, borderRadius: 8 }}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
                  <span style={{ fontWeight: 600, fontSize: 18 }}>Column {colIdx + 1}</span>
                  <button style={{ marginLeft: 16, color: "red", border: "none", background: "none", cursor: "pointer" }} onClick={() => handleRemoveColumn(colIdx)} title="Delete Column">🗑️</button>
                </div>
                <div style={{ marginBottom: 12 }}>
                  <label style={{ fontWeight: 500 }}>Column Title</label>
                  <input
                    style={{ marginLeft: 12, padding: 4, borderRadius: 4, border: "1px solid #ccc", minWidth: 180 }}
                    value={col.title}
                    onChange={e => handleColumnTitleChange(colIdx, e.target.value)}
                  />
                </div>
                <div style={{ fontWeight: 600, margin: "18px 0 8px 0" }}>Links</div>
                {col.links.map((link, linkIdx) => (
                  <div key={link.id} style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
                    <input
                      placeholder="Label"
                      style={{ marginRight: 8, padding: 4, borderRadius: 4, border: "1px solid #ccc", minWidth: 120 }}
                      value={link.label}
                      onChange={e => handleLinkChange(colIdx, linkIdx, "label", e.target.value)}
                    />
                    <input
                      placeholder="URL"
                      style={{ marginRight: 8, padding: 4, borderRadius: 4, border: "1px solid #ccc", minWidth: 120 }}
                      value={link.url}
                      onChange={e => handleLinkChange(colIdx, linkIdx, "url", e.target.value)}
                    />
                    <input
                      placeholder="Position"
                      type="number"
                      style={{ width: 60, marginRight: 8, padding: 4, borderRadius: 4, border: "1px solid #ccc" }}
                      value={link.position}
                      onChange={e => handleLinkChange(colIdx, linkIdx, "position", e.target.value)}
                    />
                    <button style={{ marginLeft: 4, color: "red", border: "none", background: "none", cursor: "pointer" }} onClick={() => handleRemoveLink(colIdx, linkIdx)} title="Delete Link">🗑️</button>
                  </div>
                ))}
                <button style={{ marginTop: 8, marginBottom: 8, border: "1.5px solid #b0bec5", borderRadius: 20, background: "#f8f9fa", color: "#333", fontWeight: 600, fontSize: 18, width: 36, height: 36, cursor: "pointer" }} onClick={() => handleAddLink(colIdx)} title="Add Link">＋</button>
              </div>
            ))}
            <div style={{ display: "flex", gap: 12, marginTop: 16 }}>
              <button style={{ border: "1.5px solid #b0bec5", borderRadius: 20, background: "#f8f9fa", color: "#333", fontWeight: 600, fontSize: 18, width: 36, height: 36, cursor: "pointer" }} onClick={handleAddColumn} title="Add Column">＋</button>
              <button style={{ border: '1.5px solid #000', borderRadius: 8, background: 'rgba(227, 221, 221, 1)', color: "#000", fontWeight: 400, fontSize: 18, padding: "8px 24px", cursor: "pointer" }} onClick={handleSave}>Save</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
